<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-right>
      <a
        class="button primary"
        *ngIf="'CreateFanClub' | hasPermission"
        [routerLink]="['./create']"
        >Create Fan Club</a
      >
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="fan-club-table"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="fan-club-page"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="'common.search-by-name' | translate"
  />
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="false"
    [sort]="sorts.get('id')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.id }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column [heading]="'common.image' | translate" id="image">
    <ng-template let-fanclub="item">
      <div class="image-placeholder">
        <img
          *ngIf="fanclub.logo as asset; else imagePlaceholder"
          [src]="asset | assetPreview : 'tiny'"
        />
        <ng-template #imagePlaceholder>
          <div class="placeholder">
            <clr-icon shape="image" size="48"></clr-icon>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.name' | translate"
    id="name"
    [hiddenByDefault]="false"
    [sort]="sorts.get('name')"
  >
    <ng-template let-fanclub="item">
      <a class="button-ghost" [routerLink]="['./', fanclub.id]"
        ><span>{{ fanclub.name }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.artistName' | translate"
    id="artistName"
    [hiddenByDefault]="false"
    [sort]="sorts.get('artistName')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.artist?.name }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.active' | translate"
    id="isActive"
    [hiddenByDefault]="true"
  >
    <ng-template let-fanclub="item">
      <vdr-chip *ngIf="fanclub.isActive" colorType="success">{{
        "common.enabled" | translate
      }}</vdr-chip>
      <vdr-chip *ngIf="!fanclub.isActive" colorType="warning">{{
        "common.disabled" | translate
      }}</vdr-chip>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.totalSalesQuantity' | translate"
    id="totalSales"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.totalSales }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'fan-club.total-members' | translate"
    id="totalMembers"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.totalMembers }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.total-links' | translate"
    id="totalLinks"
    [hiddenByDefault]="false"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.totalLinks }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="updated-at"
    [hiddenByDefault]="false"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-fanclub="item">
      {{ fanclub.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
</vdr-data-table-2>
